

















































import ChangePasswordMutation from '@/graphql/mutations/changePassword.gql';
import request from '@/graphql/request';
import { POINT_CONVERSION_COMPRESSED } from 'constants';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class ChangePassword extends Vue {
  @Prop() public showClass!: string;
  @Prop() public showText!: string;
  @Prop() public email!: string;

  public currentPassword: string = '';
  public newPassword: string = '';
  public isActive = false;
  public errorMessage: string = '';
  public disabled: boolean = false;
  public changedPassword: boolean = false;

  public sendChangePasswordRequest() {
    const email = this.email;
    const currentPassword = this.currentPassword;
    const newPassword = this.newPassword;

    this.errorMessage = '';
    this.disabled = true;
    request(ChangePasswordMutation as any, {
      email,
      currentPassword,
      newPassword,
    })
      .then(({ errors }) => {
        if (errors && errors.length) {
          throw errors;
        }
        this.disabled = false;
        this.changedPassword = true;
      })
      .catch(error => {
        this.disabled = false;
        this.errorMessage = 'Please try again.';
      });
  }

  public close() {
    this.isActive = false;
  }

  public show() {
    this.isActive = true;
    this.errorMessage = '';
    this.currentPassword = '';
    this.newPassword = '';
    this.disabled = false;
    this.changedPassword = false;
  }

  get submitClass() {
    return {
      dim: this.email && this.currentPassword && this.newPassword,
    };
  }
}
